import { ArsenalArmy } from '@Models';
import { EntityState, buildEntityState } from '../EntityState';

export type ArsenalArmiesState = EntityState<Array<ArsenalArmy>>;

export const buildArsenalArmiesState = (
  data: Partial<ArsenalArmiesState> = {},
) => buildEntityState<ArsenalArmy[]>(data);
